export default {
	memo_communication_type: 'Communication type',
	memo_created_for_label: 'Created for',
	memo_datefield_close: 'Close',
	memo_delete_dialog_confirm_cancel_label: 'No',
	memo_delete_dialog_confirm_message: 'Do you really want to delete this memo?',
	memo_delete_dialog_confirm_ok_label: 'Yes',
	memo_delete_dialog_confirm_title: 'Delete memo',
	memo_duration_label: 'Duration',
	memo_fixed_description_label: 'Description',
	memo_fixed_maturity_date_label: 'Date',
	memo_notepad_placeholder: 'Enter personal notes here...',
	memo_notepad_title: 'Notes',
	memo_save_failed_notification: 'Memo could not be saved',
	memo_saved_notification: 'Memo saved',
	memo_text_color_editor_label: 'Colors',
};
